import React from 'react'
import { useIntl } from 'react-intl'

import { HouseNightlyTripIndividualFieldProps } from '../form-container/HouseNightlyTripIndividualFormContainer'
import { ControlledSwitchField } from '../../../../../../../forms'

export const HouseNightlyTripIndividualIsEnabledField = ({
  control,
  isFieldDisabled,
}: Omit<HouseNightlyTripIndividualFieldProps, 'currencyArea'>) => {
  const intl = useIntl()

  return (
    <ControlledSwitchField
      control={control}
      name='isEnabled'
      label={intl.formatMessage({
        defaultMessage: 'Acceptez-vous les séjours avec nuitée ?',
        id: 'ui.HouseNightlyTripIndividualIsEnabledField.label',
      })}
      inline={true}
      disabled={isFieldDisabled}
    />
  )
}
